<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-08-21 17:38:10
 * @LastEditors: hexy
 * @LastEditTime: 2024-08-22 10:50:39
 * @Description: 客商组织table
 * @FilePath: \PCMS\src\views\ShareSystem\components\contract\tablePage\customerTable.vue
-->
<template>
    <div>
        <el-table ref="TableAll" :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" :data="tableDataCustomer" tooltip-effect="dark"  highlight-current-row @current-change="handleCurrentChange" @row-dblclick="rowDblclick">
          <template v-for="(item, index) in table">
            <el-table-column v-if="item" :key="index" :prop="item.prop" :label="item.label" :width="item.width" align="center"   show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="item.label == '序号'">
                  {{ scope.$index + 1 }}
                </span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
    </div>
</template>

<script>
export default {
    components: {
    },
    props:{
        tableLoadings: {
          type: Boolean
        },
        tableHeights: {
          type: Number,
        },
        tableDatasss: {
          type: Array
        },
    },
    data(){
        return {
            tableParams:{
                page:1,
                pageSize:10,
                code:"",
                name:"",
                status:1,//只查询启用状态
            },
            accessToken:"",
            total:0,
            tableDataCustomer:[],
            table:[
              { label: "序号", width: "80", prop: "id", status: true },
              { label: "客商编码", width: "auto", prop: "code", status: true },
              { label: "客商名称", width: "auto", prop: "name", status: true },
            //   { label: "税号", width: "auto", prop: "profitCenterAttributeName", status: true },
            ],
            currentRow:{},
            form:{},
        }
    },
    updated() {
        this.$nextTick(() => {
          this.$refs['TableAll'].doLayout();
        })
    },
    watch: {
      tableDatasss: {
        handler: function (val) {
          this.tableDataCustomer = val;
        },
        immediate: true,
      },
    },
    methods:{
        handleCurrentChange(val){
            this.currentRow = val;
            this.$emit("setRow",this.currentRow )
        },
        rowDblclick(val) {
          this.currentRow = val;
            this.$emit("dbClickRow",this.currentRow )
        }
    }
}
</script>


<style lang="scss" scoped>
.addClass{
  display: flex;
  justify-content: end;
  margin-bottom: 15px;
}
.mr15{
  margin-right: 15px;
}
::v-deep .el-table__body tr.current-row > td {
    color: #fff;
    background: #00b85c !important;
}
</style>
